import * as React from 'react';
import { SVGProps } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const { width, height, ...restProps } = props;
  const gradientA = 'thirdPodiumGradientA';
  const gradientB = 'thirdPodiumGradientB';
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 282 255"
      width={width}
      height={height}
      fill="none"
    >
      <path fill={`url(#${gradientA})`} d="M0 29.277h281.63V254.23H0z" />
      <path
        fill={`url(#${gradientB})`}
        d="M34.617 0h211.809l35.497 29.552H.293L34.617 0Z"
      />
      <defs>
        <linearGradient
          id={gradientA}
          x1={140.815}
          x2={140.815}
          y1={29.277}
          y2={254.23}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.125} stopColor="#FFD495" />
          <stop offset={1} stopColor="#FF9800" />
        </linearGradient>
        <linearGradient
          id={gradientB}
          x1={140.815}
          x2={140.815}
          y1={-21.999}
          y2={44.715}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.125} stopColor="#FFD495" />
          <stop offset={0.86} stopColor="#FF9800" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default SvgComponent;
